import React from "react";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { Icon } from "Icons/index";
import cx from "classnames";
import s from "./sidebarItem.scss";

class SidebarItem extends React.Component {
  goTo = () => {
    if (this.props.action) {
      this.props.action();
    } else {
      this.props.history.push(this.props.path);
    }

    this.props.toggle();
  };

  render() {
    const { selected, category, label, icon, compact, newFeature } = this.props;

    if (category) {
      return (
        <div className={cx(s.sidebarCategory, { [s.compact]: compact })}>
          {!compact && <TranslatedString>{category}</TranslatedString>}
        </div>
      );
    } else {
      return (
        <div
          className={cx(s.sidebarItem, { [s.selected]: selected, [s.compact]: compact })}
          onClick={this.goTo}
          title={compact ? t(label) : ""}
        >
          <Icon className={s.iconItem} svg={icon} width="1rem" height="1rem" />
          {!compact && <TranslatedString>{label}</TranslatedString>}
          {newFeature && <div className={s.iconNew}>New</div>}
        </div>
      );
    }
  }
}

export default SidebarItem;
